// src/data/nobishiroAbilitiesData.js
export const nobishiroAbilitiesData = [
  { 
    key: 'N', name: '粘り強さ', 
    description: '目標達成のために、困難な状況でも諦めずに粘り強く取り組む力。精神的な強さと継続力が含まれます。',
    scenarios: [
      '長期的なプロジェクトで、予期せぬ問題が発生しても計画を遂行する場面。',
      '新しいスキル習得の初期段階で、上達が見えなくても練習を続ける場面。',
      '目標達成への周囲の反対や懐疑的な意見に屈せず、自分の信念を貫く場面。',
    ],
    relatedLaws: ['law23', 'law24', 'law32', 'law38'] 
  },
  { 
    key: 'O', name: '思考力', 
    description: '物事を多角的・論理的に分析し、本質を見抜く力。問題の根本原因を探り、構造的に理解する能力を指します。',
    scenarios: [
      '複雑な業務上の問題に対し、感情や憶測ではなく、データに基づいて原因を特定する場面。',
      '複数の選択肢の中から、それぞれのメリット・デメリットを比較検討し、最適なものを選択する場面。',
      '新しい企画を立案する際に、市場のニーズや競合の動向を構造的に分析する場面。',
    ],
    relatedLaws: ['law01', 'law03', 'law04', 'law08'] 
  },
  { 
    key: 'B', name: 'バランス力', 
    description: '対立する要素や複数の要求事項に対し、最適な均衡点を見出し、調和させる力。大局的な視点と調整能力が求められます。',
    scenarios: [
      '品質（Quality）、コスト（Cost）、納期（Delivery）のトレードオフ関係の中で、最適な落とし所を見つける場面。',
      'チーム内の異なる意見を調整し、全員が納得できる合意形成を促す場面。',
      '自身の仕事と、チーム全体の目標との間で、リソース配分のバランスを取る場面。',
    ],
    relatedLaws: ['law09', 'law17', 'law28', 'law31'] 
  },
  { 
    key: 'I', name: 'イノベーション力', 
    description: '既存の枠組みや常識にとらわれず、新しいアイデアや価値、仕組みを生み出す力。創造性や発想力が中核となります。',
    scenarios: [
      'マンネリ化した業務プロセスに対し、全く新しい効率的な方法を考案・提案する場面。',
      'まだ誰も気づいていない潜在的な顧客ニーズを発見し、新しい商品やサービスのアイデアを出す場面。',
      '複数の既存技術を組み合わせて、新しい価値を持つソリューションを創造する場面。',
    ],
    relatedLaws: ['law05', 'law06', 'law07', 'law13'] 
  },
  { 
    key: 'S', name: '共感力', 
    description: '他者の感情や立場、価値観を深く理解し、寄り添う力。良好な人間関係を築き、信頼を得るための基礎となります。',
    scenarios: [
      '顧客からのクレームに対し、相手の怒りの裏にある本当の気持ちを汲み取り、対応する場面。',
      '悩んでいる同僚の話を聞き、解決策を急ぐのではなく、まずその気持ちを受け止める場面。',
      '自分とは異なる文化や背景を持つ人々と、その価値観を尊重しながらコミュニケーションを取る場面。',
    ],
    relatedLaws: ['law11', 'law13', 'law14', 'law22'] 
  },
  { 
    key: 'H', name: '協働力', 
    description: '多様なバックグラウンドを持つ人々と協力し、1+1を2以上にする力。チームとして相乗効果を生み出す能力です。',
    scenarios: [
      '部門の垣根を越えたプロジェクトで、異なる専門性を持つメンバーの知識やスキルを引き出し、目標を達成する場面。',
      'チームの成功のために、自分の担当範囲外の仕事でも積極的にサポートし、貢献する場面。',
      'オンライン会議などで、全員が発言しやすい雰囲気を作り、チーム全体のアイデアを引き出す場面。',
    ],
    relatedLaws: ['law12', 'law17', 'law19', 'law35'] 
  },
  { 
    key: 'I2', name: '主体性', 
    description: '指示を待つのではなく、自らの意思で率先して行動を起こし、周囲を巻き込んでいく力。当事者意識とも言えます。',
    scenarios: [
      'まだ誰も手をつけていない課題や問題に気づき、自ら解決策を提案し、行動を始める場面。',
      '会議で議論が停滞した際に、新しい視点を提供したり、議論を前に進めるための発言をする場面。',
      '自身のキャリアパスについて、会社任せにせず、自ら目標を設定し学習や経験を積んでいく場面。',
    ],
    relatedLaws: ['law02', 'law18', 'law21', 'law39'] 
  },
  { 
    key: 'R', name: '振り返り力', 
    description: '自らの経験や行動の結果を客観的に評価・分析し、得られた教訓を次の行動に活かす力。成長のサイクルを回す上で不可欠です。',
    scenarios: [
      '大きなプレゼンテーションの後、成功点と反省点を具体的に書き出し、次回の改善計画を立てる場面。',
      'うまくいかなかった仕事について、他責にせず、自身の判断や行動のどこに改善の余地があったかを分析する場面。',
      '1週間の終わりに、その週の活動を振り返り、翌週の生産性を高めるための計画を立てる場面。',
    ],
    relatedLaws: ['law03', 'law08', 'law10', 'law27'] 
  },
  { 
    key: 'O2', name: '最適化力', 
    description: '現状のプロセスや仕組みを分析し、より無駄がなく効率的な状態へと改善していく力。継続的な改善能力です。',
    scenarios: [
      '毎日行っている定型的なデータ入力作業に対し、マクロやスクリプトを用いて自動化する方法を考える場面。',
      'チームの情報共有方法を見直し、より迅速かつ正確に情報が伝わるツールやルールを導入する場面。',
      '自身の時間管理術を分析し、集中力が高い時間帯に重要な仕事を割り当てるなど、1日の生産性を最大化する場面。',
    ],
    relatedLaws: ['law10', 'law25', 'law33', 'law34'] 
  },
];
